import {
    Filter,
    ExactFilter,
    isExactFilter,
    ExactSign,
    isMembershipFilter,
    MembershipFilter,
    MembershipSign,
} from 'utils/filter/filter';
import NumberExpression from 'utils/filter/expressions/NumberExpression';
import StringExpression from '../expressions/StringExpression';
import { isNumber } from 'utils/validations/number';
import MembershipStringExpression from 'utils/filter/expressions/MembershipStringExpression';

export default function buildEnumFilterFunction(
    filter: Filter<number | string>
) {
    if (isExactFilter(filter)) {
        return buildEnumExactFilterFunction(filter);
    }
    if (
        isMembershipFilter(filter) &&
        filter.values.length > 0 &&
        typeof filter.values[0] === 'string'
    ) {
        return buildMembershipFilterFunction(
            filter as MembershipFilter<string>
        );
    }
    return () => true;
}

function buildEnumExactFilterFunction(
    exactFilter: ExactFilter<number | string>
) {
    if (isNumber(exactFilter.value as string)) {
        const expression = new NumberExpression(
            exactFilter.value as number,
            1,
            1
        );
        switch (exactFilter.exactSign) {
            case ExactSign.EQ:
                return expression.testEqual.bind(expression);
            case ExactSign.NEQ:
                return expression.testNotEqual.bind(expression);
            default:
                return () => true;
        }
    } else {
        const expression = new StringExpression(exactFilter.value as string);
        switch (exactFilter.exactSign) {
            case ExactSign.EQ:
                return expression.testIsEqual.bind(expression);
            case ExactSign.NEQ:
                return expression.testNotEqual.bind(expression);
            default:
                return () => true;
        }
    }
}

function buildMembershipFilterFunction(filter: MembershipFilter<string>) {
    if (filter.values.length === 0) {
        return () => true;
    }

    const expression = new MembershipStringExpression(
        filter.values as string[]
    );
    switch (filter.membershipSign) {
        case MembershipSign.INCLUDE:
            return expression.testIsOneOf.bind(expression);
        case MembershipSign.EXCLUDE:
            return expression.testNotIsOneOf.bind(expression);

        default:
            return () => true;
    }
}
